import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from '../../api-config';

const PaginatedUserTable = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(5); // Número de usuarios por página
  const [error, setError] = useState('');
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${API_URL}/users-api/users/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            accept: 'application/json',
          },
        });
        setUsers(response.data);
      } catch (err) {
        setError('Failed to fetch users');
      }
    };

    fetchUsers();
  }, []);

  // Lógica para obtener los usuarios de la página actual
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = [...users]
    .sort((a, b) => a.id - b.id)
    .slice(indexOfFirstUser, indexOfLastUser);

  // Cambiar página
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="p-8 bg-[#101523] ">
      <h2 className="text-2xl font-bold text-center mb-4">User List</h2>
      {error && <div className="p-2 mb-4 text-sm text-red-700 bg-red-200 rounded">{error}</div>}
      <table className="min-w-full border rounded-lg shadow-md " >
        <thead>
          <tr>
            <th className="py-2 px-4 border-b">ID</th>
            <th className="py-2 px-4 border-b">Email</th>
            <th className="py-2 px-4 border-b">Username</th>
            <th className="py-2 px-4 border-b">First Name</th>
            <th className="py-2 px-4 border-b">Last Name</th>
          </tr>
        </thead>
        <tbody>
        {currentUsers.map((user) => (
  <tr key={user.id}>
    <td className="py-2 px-4 border-b">
      <Link to={`/users/info/${user.id}`} className=" hover:text-blue-400">
        {user.id}
      </Link>
    </td>
    <td className="py-2 px-4 border-b">
      <Link to={`/users/info/${user.id}`} className=" hover:text-blue-400">
        {user.email}
      </Link>
    </td>
    <td className="py-2 px-4 border-b">
      <Link to={`/users/info/${user.id}`} className=" hover:text-blue-400">
        {user.username}
      </Link>
    </td>
    <td className="py-2 px-4 border-b">{user.first_name || 'N/A'}</td>
    <td className="py-2 px-4 border-b">{user.last_name || 'N/A'}</td>
  </tr>
))}

        </tbody>
      </table>
      <div className="mt-4 flex justify-center">
        <Pagination
          usersPerPage={usersPerPage}
          totalUsers={users.length}
          paginate={paginate}
        />
      </div>
    </div>
  );
};

// Componente de paginación
const Pagination = ({ usersPerPage, totalUsers, paginate }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalUsers / usersPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className="flex list-none">
        {pageNumbers.map((number) => (
          <li key={number} className="px-2">
            <button
              onClick={() => paginate(number)}
              className="px-4 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none"
            >
              {number}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default PaginatedUserTable;
